document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
        var targetToggle = e.target.closest('.js-jumpToToggle');
        if (targetToggle) {
            e.preventDefault();

            var jumpToShowText = document.querySelector('.c-jump-to__show');
            if (jumpToShowText) {
                jumpToShowText.textContent = (jumpToShowText.textContent === "show") ? "hide" : "show";
            }

            var target_selector = targetToggle.getAttribute('data-target');
            var target = document.querySelector(target_selector);
            targetToggle.classList.toggle('is-active');
            if (target.style.display === "none" || target.style.display === "") {
                target.style.display = "block";
            } else {
                target.style.display = "none";
            }
        }
    });

    var jumpToList = document.querySelector(".c-jump-to__list");
    if (jumpToList) {
        var jumps = document.querySelectorAll(".c-jump-to__item");
        var headers = document.querySelectorAll("#page-content h2:not(.no-jump)");

        headers.forEach(function (header, index) {
            if (jumps[index]) {
                var link = jumps[index].querySelector('.c-jump-to__link');
                var href_value = link.getAttribute('href').substring(1);
                var text = link.textContent;

                header.setAttribute("id", href_value);
                var newElement = document.createElement('span');
                newElement.className = 'c-header--overline';
                newElement.textContent = padLeadingZeros((index + 1), 2) + '. ' + text;
                header.parentNode.insertBefore(newElement, header);
            }
        });

        if (window.location.hash && !window.location.hash.includes("#:~:text")) {
            var decodedHash = decodeURIComponent(window.location.hash);
            decodedHash = slugify(decodedHash);
            var target = document.querySelector(decodedHash);
            if (target) {
                var targetTop = target.offsetTop + parseInt(window.getComputedStyle(target)['padding-top'], 10);
                window.scrollTo({
                    top: targetTop,
                    behavior: 'smooth'
                });
            }
        }
        var event = new Event('jump-to-complete');
        window.dispatchEvent(event);
    }

    function padLeadingZeros(num, size) {
        return String(num).padStart(size, '0');
    }
});


function slugify(str) {
    return str.toString() // Convert to string
        .toLowerCase() // Convert the string to lowercase letters
        .trim() // Remove whitespace from both sides of a string
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars (regex for word characters are \w)
        .replace(/\-\-+/g, '-'); // Replace multiple - with single -
}
